import { render, staticRenderFns } from "./SingleViewOrder.vue?vue&type=template&id=b2d71a4c&"
import script from "./SingleViewOrder.vue?vue&type=script&lang=js&"
export * from "./SingleViewOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports